import React from 'react'
import loader from '../assets/gif/loader.json'
import { LottieAnimation } from './LottieAnimation'

function Loader({style, h=100}) {
  return (
    <div className='d-flex align-items-center justify-content-center' style={{height:`${h}vh`}}>
        <LottieAnimation src={loader} style={{style}} />
    </div>
  )
}

export default Loader